package org.example.zone360.pages.dashboard.seasonSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.CustomDatePicker
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.InputField
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetClubSeasonData
import org.example.zone360.models.SaveClubSeasonPayload
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.normalizeText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement
import org.example.zone360.utils.saveClubSeason

@Composable
fun CreateClubSeason(
    onDialogDismiss: (Long) -> Unit,
    onCloses: () -> Unit,
    breakpoint: Breakpoint,
    modalNumber: Long,
    isEditMode: Boolean = false,
    seasonData: GetClubSeasonData,
    sitePalette: SitePalette,
    toastMessageCall: (String) -> Unit,
    disableActiveField1: Boolean
){
    val scope = rememberCoroutineScope()
    var isLoading by remember { mutableStateOf(false) }
    var serverError by remember { mutableStateOf("") }
    var isError by remember { mutableStateOf(false) }
    var startDate by remember { mutableStateOf("") }
    var endDate by remember { mutableStateOf("") }
    var seasonNameErrorText by remember { mutableStateOf("") }
    var startDateError by remember { mutableStateOf(false) }
    var disableActiveField by remember { mutableStateOf(disableActiveField1) }
    var endDateError by remember { mutableStateOf(false) }
    var showAlert by remember { mutableStateOf(false) }
    var selectSeasonStatus by remember { mutableStateOf(if (disableActiveField) "Active" else "Inactive") }


        LaunchedEffect(Unit) {
            if (!isEditMode) return@LaunchedEffect
            (document.getElementById("${Res.Id.seasonName}-$modalNumber") as HTMLInputElement).value =
                seasonData.name
            startDate = seasonData.startDate
            endDate = seasonData.endDate
            selectSeasonStatus = seasonData.status.replaceFirstChar { it.uppercase() }
            if (seasonData.status == Strings.ACTIVE) {
                disableActiveField = true
            }
    }


    if (showAlert) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(sitePalette.fadedBlack.rgb)
            .position(Position.Fixed)
            .top(0.px).left(0.px)
            .zIndex(99),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .width(320.px)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(12.px)
                .padding(24.px)
                .border(1.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                text = "Activate Season?",
                fontSize = 16.px,
                fontWeight = 600
            )
            CustomSpacer(height = 8.px)
            FieldTitleTextNormalSimple(
                text = "This will automatically deactivate the current active season.",
                fontSize = 13.px,
                color = sitePalette.textFieldSupportiveTextColor.rgb,
                textAlign = TextAlign.Center
            )
            CustomSpacer(height = 20.px)
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(10.px)
            ) {
                CommonButton(
                    text = "Cancel",
                    byPassEmailVerification = true,
                    width = 100.percent,
                    borderColor = sitePalette.primary.rgb,
                    backgroundColor = Colors.Transparent,
                    textSpanColor = sitePalette.primary.rgb,
                    height = 40.px,
                    onCLick = {
                        selectSeasonStatus = "Inactive"
                        showAlert = false
                    }
                )
                CommonButton(
                    text = "Confirm",
                    byPassEmailVerification = true,
                    width = 100.percent,
                    height = 40.px,
                    onCLick = {
                        selectSeasonStatus = "Active"
                        showAlert = false
                    }
                )
            }
        }
    }
}
    Box(
        modifier = Modifier
            .width(if (breakpoint < Breakpoint.MD) 350.px else 450.px)
            .minHeight(560.px)
            .id("${Res.Id.createClubSeason}-$modalNumber")
            .position(Position.Fixed)
            .zIndex(9)
            .top(50.percent)
            .left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier
                .width(90.percent)
                .height(90.percent)
                .onClick { }
        )
        Box(
            modifier = Modifier
                .padding(all = 24.px)
                .width(90.percent)
                .margin(top = 10.px)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                )
                .borderRadius(4.px)
                .overflow(Overflow.Auto),
            contentAlignment = Alignment.Center,
        ) {
            Column(modifier = Modifier.fillMaxSize()) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 20.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column {
                        FieldTitleTextNormalSimple(
                            if (isEditMode)"Edit Season" else "Create Season",
                            fontSize = 20.px,
                            fontWeight = 600,
                            onClick = {}
                        )
                    }

                    FaXmark(
                        modifier = Modifier
                            .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                            .cursor(Cursor.Pointer)
                            .onClick { onCloses() },
                        size = IconSize.LG
                    )

                }
                Column(
                    Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.Center
                ) {

                    FieldTitleTextNormal(text = "Season Name", onClick = {})
                    InputField(
                        onValueChange = {
                                seasonNameErrorText = ""
                                isError = false

                        },
                        inputType = InputType.Text,
                        placeHolder = "Enter Season Name",
                        marginBottom =  3.px,
                        id = "${Res.Id.seasonName}-$modalNumber",
                        width = if (breakpoint < Breakpoint.MD) 266.px else 350.px
                    )
                    if (seasonNameErrorText.isNotEmpty()) {
                        FieldTitleTextNormal(
                            text = seasonNameErrorText,
                            color = sitePalette.textErrorColor.rgb,
                            fontSize = 11.px,
                            onClick = {}
                        )
                    }
                    CustomSpacer(height = 20.px)
                    Column(modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)) {
                        FieldTitleTextNormal(text = "Start Date", onClick = {})
                        CustomDatePicker(
                            id = Res.Id.startDate,
                            width = 100.percent,
                            value = startDate,
                            placeHolder = Strings.YYYY_MM_DD,
                            onValueChange = {
                                startDate = it
                                startDateError = false
                            },
                             notSelected = { selectedDateStr ->
                                if (endDate.isNotEmpty() && selectedDateStr > endDate) {
                                    toastMessageCall("Start date cannot be after end date")
                                    showToast(ToastID.ERROR)
                                    true
                                } else false
                            }
                        )
                        if (startDateError) {
                            FieldTitleTextNormal(marginTop = 3.px,
                                fontSize = 11.px,
                                text = "Please select start date",
                                color = sitePalette.textErrorColor.rgb,
                                onClick = {})
                        }
                    }
                    Column(modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)) {
                        FieldTitleTextNormal(text = "End Date", onClick = {})
                        CustomDatePicker(
                            id = Res.Id.endDate,
                            width = 100.percent,
                            value = endDate,
                            placeHolder = Strings.YYYY_MM_DD,
                            onValueChange = {
                                endDate = it
                                endDateError = false
                            },
                            notSelected = { selectedDateStr ->
                                if (startDate.isNotEmpty() && selectedDateStr < startDate) {
                                    toastMessageCall("End date cannot be before start date")
                                    showToast(ToastID.ERROR)
                                    true
                                } else false
                            }

                        )
                        if (endDateError) {
                            FieldTitleTextNormal(marginTop = 3.px,
                                fontSize = 11.px,
                                text = "Please select end date",
                                color = sitePalette.textErrorColor.rgb,
                                onClick = {})
                        }
                    }
                    Column(modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)) {
                        FieldTitleTextNormal(text = "Season Status", onClick = {})
                        CommonDropdown(
                            data = listOf("Active", "Inactive"),
                            onSelect = {
                                if (it == "Active") {
                                    showAlert = true
                                } else {
                                    selectSeasonStatus = "Inactive"
                                    showAlert = false
                                }
                            },
                            selectedItem = selectSeasonStatus,
                            width = 100.percent,
                            disabled = disableActiveField
                        )

                    }
                }

                Box {
                    CommonButton(
                        byPassEmailVerification = true,
                        text = "Save",
                        isLoading = isLoading,
                        onCLick = {
                            scope.launch {
                                val seasonName = (document.getElementById("${Res.Id.seasonName}-$modalNumber") as HTMLInputElement).value

                                // Validation checks
                                isError = false

                                if (seasonName.isEmpty()){
                                    seasonNameErrorText = "Please enter season name"
                                    isError = true
                                    return@launch
                                }
                                if (seasonName.contains("/")){
                                    seasonNameErrorText = "Season name cannot contain /"
                                    isError = true
                                    return@launch
                                }

                                if (startDate.isEmpty()){
                                    startDateError = true
                                    return@launch
                                }
                                if (endDate.isEmpty()){
                                    endDateError = true
                                    return@launch
                                }
                                if (showAlert){
                                    toastMessageCall("First confirm the season status")
                                    showToast(ToastID.ERROR)
                                    return@launch
                                }
                                isLoading = true
                                isError = false
                                serverError = ""
                                try {
                                    val payload = SaveClubSeasonPayload(
                                        seasonId = if (isEditMode) seasonData.id else "",
                                        organization = AppGlobal.userData.organization,
                                        name = normalizeText(seasonName),
                                        startDate = startDate,
                                        endDate = endDate,
                                        status = selectSeasonStatus.lowercase(),
                                    )

                                    val response = saveClubSeason(payload)
                                    if (!response.error.isNullOrBlank()) {
                                        isError = true
                                        serverError = response.error
                                    } else {
                                        toastMessageCall(response.data ?: "Season created successfully")
                                        showToast(ToastID.SUCCESS)
                                        onDialogDismiss(modalNumber)
                                    }
                                } catch (e: Throwable) {
                                    isError = true
                                    serverError = "Failed to create season. Please try again."
                                } finally {
                                    isLoading = false
                                }
                            }
                        },
                        width = if (breakpoint < Breakpoint.MD) 266.px else 350.px,
                        height = 45.px
                    )
                }
                if (serverError.isNotEmpty()) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        FieldTitleTextNormal(
                            text = serverError,
                            color = sitePalette.textErrorColor.rgb,
                            fontSize = 12.px,
                            marginTop = 10.px,
                            textAlign = TextAlign.Center,
                            onClick = {})
                    }
                }
            }
        }
    }

}